
export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-stone-100 to-stone-200 text-gray-800">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <img
              src="https://static.readdy.ai/image/46842361a9a2459ecf5ba33a5b883dd8/90a57919dae4ac2ac89acc01fa70c171.png"
              alt="Sailing Logo"
              className="h-16 w-auto object-contain mb-6"
            />
            <p className="text-gray-600 text-sm leading-relaxed mb-6">
              Experience the freedom of sailing with our expert-led cruising and racing programs designed for all skill levels.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://instagram.com/sailrebels/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-slate-700 hover:bg-amber-600 rounded-full flex items-center justify-center transition-colors cursor-pointer text-white"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6 text-gray-900">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('home')}
                  className="text-gray-600 hover:text-amber-600 transition-colors text-sm cursor-pointer"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('cruising')}
                  className="text-gray-600 hover:text-amber-600 transition-colors text-sm cursor-pointer"
                >
                  Cruising
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('racing')}
                  className="text-gray-600 hover:text-amber-600 transition-colors text-sm cursor-pointer"
                >
                  Racing
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('training')}
                  className="text-gray-600 hover:text-amber-600 transition-colors text-sm cursor-pointer"
                >
                  Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('gallery')}
                  className="text-gray-600 hover:text-amber-600 transition-colors text-sm cursor-pointer"
                >
                  Gallery
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-gray-600 hover:text-amber-600 transition-colors text-sm cursor-pointer"
                >
                  About Us
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6 text-gray-900">Services</h4>
            <ul className="space-y-3 text-sm text-gray-600">
              <li>Professional Yacht Delivery</li>
              <li>Professional Skipper Services</li>
              <li>Navigation&Weather Routing</li>
              <li>Cruising</li>
              <li>Racing Programs</li>
              <li>Race Training</li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6 text-gray-900">Contact Info</h4>
            <ul className="space-y-4 text-sm text-gray-600">
              <li className="flex items-start">
                <i className="ri-map-pin-line mr-3 mt-1 text-amber-600"></i>
                <span>Gocek/Türkiye</span>
              </li>
              <li className="flex items-center">
                <i className="ri-phone-line mr-3 text-amber-600"></i>
                <span>+90 534 370 64 33<br />+33 6 52 51 55 04</span>
              </li>
              <li className="flex items-center">
                <i className="ri-mail-line mr-3 text-amber-600"></i>
                <span>info@sailrebels.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-stone-300 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm text-gray-500">
            <p>© 2025 Sail Rebels. All rights reserved.</p>
            <div className="flex items-center space-x-6 mt-4 md:mt-0">
              <a href="#" className="hover:text-amber-600 transition-colors cursor-pointer">
                Privacy Policy
              </a>
              <a href="#" className="hover:text-amber-600 transition-colors cursor-pointer">
                Terms of Service
              </a>
              <a 
                href="https://readdy.ai/?ref=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:text-amber-600 transition-colors cursor-pointer"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
